import React, { memo, useEffect, useState } from 'react'
import { Button, Message } from '@arco-design/web-react'

const theKey = 'sms_cdtime'

const SmsButton = memo
(({
  initialCount = 30,
  onClick,
  buttonText = '获取验证码',
  style,
}) => {
  const [count, setCount] = useState(() => {
    const savedEndTime = localStorage.getItem(theKey)
    if (savedEndTime) {
      const remainingTime = Math.ceil((savedEndTime - Date.now()) / 1000)
      return remainingTime > 0 ? remainingTime : 0
    }
    return 0
  })
  const [isCounting, setIsCounting] = useState(() => {
    const savedEndTime = localStorage.getItem(theKey)
    return savedEndTime && savedEndTime > Date.now()
  })

  useEffect(() => {
    let timer
    if (isCounting && count > 0) {
      timer = setInterval(() => {
        const savedEndTime = localStorage.getItem(theKey)
        if (savedEndTime) {
          const remainingTime = Math.ceil((savedEndTime - Date.now()) / 1000)
          if (remainingTime > 0) {
            setCount(remainingTime)
          } else {
            setIsCounting(false)
            setCount(0)
            localStorage.removeItem(theKey)
          }
        }
      }, 1000)
    }
    return () => clearInterval(timer)
  }, [isCounting, count])

  const handleClick = () => {
    if (isCounting) {
      Message.warning('请等待倒计时结束')
      return
    }
    if (onClick) {
      onClick()
    }
    setIsCounting(true)
    const newEndTime = Date.now() + initialCount * 1000
    setCount(initialCount)
    localStorage.setItem(theKey, newEndTime)
    Message.success('验证码已发送')
  }

  return (
    <Button style={style} onClick={handleClick} disabled={isCounting}>
      {isCounting ? `重新获取 (${count})` : buttonText}
    </Button>
  )
})

export default SmsButton
